import React, { useState } from "react";
import { motion } from "framer-motion";
import AboutSection from "./AboutUs";
import ResumeModal from "./ResumeModal";
import ContactSection from "./ContactSection";

export default function TalentSqueedPage() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [open, setOpen] = useState(false);

  const industries = [
    { name: "IT", icon: "💻" },
    { name: "Healthcare", icon: "🏥" },
    { name: "Engineering & Manufacturing", icon: "⚙️" },
    { name: "Pharma", icon: "💊" },
    { name: "Education & Training", icon: "📘" },
    { name: "Automobile", icon: "🚗" },
    { name: "Telecom & ISP", icon: "📡" },
  ];

  return (
    <div className="bg-white text-gray-900 font-sans">
      {/* ======================= NAVBAR ======================= */}
      <nav className="w-full sticky top-0 bg-white shadow-sm z-50">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <a href="#home" className="hover:text-cyan-600">
              <img src="/logo.png" className="w-32 h-12 rounded-md" />
            </a>
            <span className="text-2xl font-bold tracking-wide text-gray-800"></span>
          </div>

          {/* Desktop Menu */}
          <ul className="hidden md:flex space-x-10 text-lg font-medium">
            <li>
              <a href="#home" className="hover:text-cyan-600">
                Home
              </a>
            </li>
            <li>
              <a href="#about" className="hover:text-cyan-600">
                About Us
              </a>
            </li>
            <li>
              <a href="#career" className="hover:text-cyan-600">
                Career
              </a>
            </li>
            <li>
              <a href="#contact" className="hover:text-cyan-600">
                Contact
              </a>
            </li>
          </ul>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-3xl"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        </div>

        {/* Mobile Dropdown */}
        {menuOpen && (
          <div className="md:hidden bg-white shadow-md px-6 pb-4">
            <ul className="space-y-4 text-lg font-medium">
              <li>
                <a href="#home" className="block">
                  Home
                </a>
              </li>
              <li>
                <a href="#about" className="block">
                  About Us
                </a>
              </li>
              <li>
                <a href="#career" className="block">
                  Career
                </a>
              </li>
              <li>
                <a href="#contact" className="block">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        )}
      </nav>

      {/* ======================= HERO SECTION ======================= */}
      <section
        id="home"
        style={{ paddingTop: "1rem" }}
        className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center"
      >
        {/* LEFT TEXT */}
        <div>
          <h1 className="text-5xl lg:text-6xl font-extrabold leading-tight mb-6">
            The Easy Way To Get <br /> Your New Job
          </h1>
          <p className="text-gray-600 text-lg leading-relaxed mb-10">
            Candidates are requested to submit their resume along with details
            below mentioned to process their candidature.
          </p>

          {/* Search Filters */}
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
            <input
              type="text"
              placeholder="Keyword e.g. (Job Title, Description)"
              className="border px-4 py-3 rounded-lg shadow-sm focus:ring-2 focus:ring-cyan-500"
            />
            <select className="border px-4 py-3 rounded-lg shadow-sm">
              <option>Select Location</option>
              <option>Gurgaon</option>
              <option>Delhi</option>
              <option>Noida</option>
            </select>

            <select className="border px-4 py-3 rounded-lg shadow-sm">
              <option>Category</option>
              <option>IT</option>
              <option>Healthcare</option>
            </select>

            <select className="border px-4 py-3 rounded-lg shadow-sm">
              <option>Experience</option>
              <option>0-1 Years</option>
              <option>1-3 Years</option>
            </select>
          </div>

          <button className="bg-cyan-600 hover:bg-cyan-700 text-white px-10 py-4 rounded-lg shadow-md text-lg">
            Search
          </button> */}
        </div>

        {/* RIGHT IMAGE */}
        <div className="flex justify-center">
          <img
            src="/25460.png"
            className="w-full max-w-lg lg:max-w-xl drop-shadow-xl"
          />
        </div>
      </section>

      {/* ======================= INDUSTRIES SECTION ======================= */}
      <section className="px-6 py-20 bg-gray-50">
        <h2 className="text-4xl font-bold text-center mb-14">
          Industries We Serve
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {industries.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="p-8 bg-white rounded-xl shadow-sm text-center border hover:shadow-lg transition"
            >
              <div className="text-5xl mb-3">{item.icon}</div>
              <div className="text-xl font-semibold">{item.name}</div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ======================= ABOUT SECTION ======================= */}
      <AboutSection>
        <h2 className="text-4xl font-bold mb-8">About Us</h2>

        <p className="text-gray-600 text-lg leading-relaxed mb-6">
          Talent Squeed is one of India's leading HR Consulting firms,
          specializing in Human Resources, Knowledge Services (Training &
          Assessments), and Business Consulting. We started with a vision to
          redefine industry benchmarks through niche, turnkey HR assignments and
          have grown to serve clients across diverse geographies.
        </p>

        <p className="text-gray-600 text-lg leading-relaxed mb-6">
          Known for our quality and commitment, Talent Squeed is a preferred
          partner for Recruitment and other corporate HR solutions. Powered by
          globally qualified and experienced professionals, we provide business
          services that help organizations enter new markets confidently,
          increase profitability, achieve operational efficiency, and stay ahead
          of competition.
        </p>

        <p className="text-gray-600 text-lg leading-relaxed mb-6">
          Our offerings include Human Resource Outsourcing (Payroll, PMS, HRD,
          Training, Legal Support, Assessments) and Customer Care solutions,
          along with expert advisory services tailored to organizational needs.
        </p>

        <p className="text-gray-600 text-lg leading-relaxed">
          Our commitment to client satisfaction strengthens long-term
          partnerships. Talent Squeed stands out with its deep industry
          expertise, wide service offerings, proven capabilities in business
          transformation, and an experienced, results-oriented leadership team.
        </p>
      </AboutSection>

      {/* ======================= CAREER SECTION ======================= */}
      <section id="career" className="px-6 py-20 max-w-5xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-8">Career</h2>
        <p className="text-gray-700 text-xl leading-relaxed mb-8 font-medium">
          Join one of the fastest-growing recruitment teams…
        </p>
        <button
          onClick={() => setOpen(true)}
          className="bg-cyan-600 hover:bg-cyan-700 text-white px-10 py-4 rounded-full text-lg shadow-lg transition-all"
        >
          Explore Opportunities
        </button>

        <ResumeModal open={open} onClose={() => setOpen(false)} />
      </section>

      {/* ======================= CONTACT SECTION ======================= */}
      <ContactSection></ContactSection>

      {/* ======================= FOOTER ======================= */}
      <footer className="bg-gray-900 text-gray-300 py-6 text-center text-sm">
        © 2025 Talent Squeed | All Rights Reserved
      </footer>
    </div>
  );
}
